import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_API.replace('/api', ''), {
  transports: ['websocket'],
  autoConnect: false,
});

// Evita a tentativa de conexão real
socket.connect = () => {};

export default socket;